import { render } from "./PageSchedule.vue?vue&type=template&id=6b8c5ee6&scoped=true"
import script from "./PageSchedule.vue?vue&type=script&lang=js"
export * from "./PageSchedule.vue?vue&type=script&lang=js"

import "./PageSchedule.vue?vue&type=style&index=0&id=6b8c5ee6&scoped=true&lang=css"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8c5ee6"]])

export default __exports__